import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.css'],
  standalone: true,
})
export class UnauthorizedComponent implements OnInit {

  constructor(private router: Router) {}

  ngOnInit(): void {
    // Auto redirect after 2 seconds
    setTimeout(() => {
      this.router.navigate(['/auth/login']);
    }, 2000);
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }
}
